module.exports = __webpack_public_path__ + "img/SBCP.07f450d0.jpg";